export const EVENT_PARAMETERS = {
  FIRST_NAME: "first_name",
  LAST_NAME: "last_name",
  EMAIL_ADDRESS: "email",
  OFFER: "offer",
  PAGE_NAME: "page_name",
  BUTTON_TEXT: "button_text",
  BUTTON_TYPE: "button_type",
  BUTTON_ROLE: "button_role",
  BANNER_HEADLINE: "banner_headline",
  MODAL_NAME: "modal_name",
  CURRENT_PLAN_TIER: "current_plan_tier",
  TARGET_PLAN_TIER: "target_plan_tier",
  MESSAGE_NUMBER: "message_number",
  SIGNUP_METHOD: "signup_method",
  SIGNIN_METHOD: "signin_method",
  LEGAL_PERSONA: "legal_persona",
  THREAD_ID: "thread_id",
  PREV_THREAD_ID: "prev_thread_id",
  TARGET_THREAD_ID: "target_thread_id",
  FROM_IDENTITY: "from_identity",
  TO_IDENTITY: "to_identity",
  WAIT_MS: "wait_ms",
  REMAP_ATTEMPTED: "remap_attempted",
  REMAP_OUTCOME: "remap_outcome",
  BATCH_SIZE: "batch_size",
  ATTEMPTED_COUNT: "attempted_count",
  SUCCESS_COUNT: "success_count",
  ALREADY_MAPPED_COUNT: "already_mapped_count",
  BELONGS_TO_OTHER_COUNT: "belongs_to_other_count",
  INVALID_COUNT: "invalid_count",
  MAP_SOURCE: "map_source",
  ERROR_STATUS: "error_status",
  HISTORY_SIZE: "history_size",
  USER_ID: "user_id",
  USER_EMAIL: "user_email",
  COMET_TOKEN: "comet_token",
  AUTO_TRIGGER: "auto_trigger",
  TARGET_CHECKBOX_STATE: "target_checkbox_state",
  INITIAL_CHECKBOX_STATE: "initial_checkbox_state",
  UTM_CAMPAIGN: "utm_campaign",
  UTM_SOURCE: "utm_source",
  UTM_MEDIUM: "utm_medium",
  UTM_THREAD_ID: "thread_id",
  REFERRAL_CATEGORY: "referral_category",
  LEGAL_REVIEW_CREDITS_TOTAL: "legal_review_credits_total",
  LEGAL_REVIEW_CREDITS_USED: "legal_review_credits_used",
  LAWYER_ASSIGNED: "lawyer_assigned",
  SESSION_ID: "session_id",
  DOCUMENT_ID: "document_id",
  IS_LOCKED: "is_locked",
  MESSAGE_ID: "message_id",
  TIME_SINCE_UNLOCK_START: "time_since_unlock_start",
  PAYMENT_ID: "payment_id",
  CHECKOUT_FLOW: "checkout_flow",
  PAYMENT_STATUS: "payment_status",
  ERROR_MESSAGE: "error_message",
  COUPON_CODE: "coupon_code",
  DISCOUNT_DESCRIPTION: "discount_description",
  CARD_FIELD: "card_field",
  BILLING_COMPLETE: "billing_complete",
  // Payment failure diagnostics
  DECLINE_CODE: "decline_code",
  FAILURE_STAGE: "failure_stage", // "tokenize" | "api_call" | "api_response"
  USING_SAVED_CARD: "using_saved_card",
  // Gateway scoping (two Chargebee gateway accounts: Inhouse Inc / Inhouse Counsel PC).
  // Values are BE-issued labels ("inc" | "pc") — the FE never derives them from a plan.
  PAYMENT_GATEWAY: "payment_gateway",
  SAVED_CARDS_TOTAL: "saved_cards_total",
  // Why checkout sent the customer to card entry:
  // "no_eligible_saved_card" | "needs_new_card"
  CARD_ENTRY_REASON: "card_entry_reason",
  HTTP_STATUS: "http_status",
  CARD_BRAND: "card_brand",
  CARD_LAST4: "card_last4",
  VALIDATION_ERROR: "validation_error",
  PAYMENT_VALIDATION_ERROR: "payment_validation_error",
  // Reliability / health tracking
  WAIT_DURATION_SECONDS: "wait_duration_seconds",
  LATENCY_MS: "latency_ms",
  RESPONSE_MILESTONE: "response_milestone",
  TRIGGER_ID: "trigger_id",
  ERROR_TYPE: "error_type",
  APP_BUILD_NUMBER: "app_build_number",
  MINUTES_SINCE_PAYMENT: "minutes_since_payment",
  VERSION_ACTION: "version_action",
  CLIENT_BUILD: "client_build",
  SERVER_BUILD: "server_build",
  URL: "url",
  PAYMENT_VALUE: "payment_value",
  AMOUNT: "amount",
  PRODUCT_TYPE: "product_type",
  MEMORY_SECTION: "memory_section",
  MEMORY_ITEM_ID: "memory_item_id",
  EMAIL_THREAD_ID: "email_thread_id",
  HEADER_COPY: "header_copy",
  MODAL_TYPE: "modal_type",
  LEGAL_REVIEW_CREDITS_REMAINING: "legal_review_credits_remaining",
  EMAIL_THREAD_ID_CLICKED: "email_thread_id_clicked",
  EMAIL_THREADS_SELECTED_COUNT: "email_threads_selected_count",
  // Upload-reliability funnel (F-fe) — joined with the backend funnel by storage_id / thread_id
  STORAGE_ID: "storage_id",
  ATTACHMENT_STATE: "attachment_state",
  ATTACHMENT_ID: "attachment_id",
  // Chat composer list formatting — "ordered" | "unordered"
  LIST_TYPE: "list_type",
  // Chat composer list nesting — "indent" | "outdent"
  INDENT_DIRECTION: "indent_direction",
  // Subscription lifecycle (data-layer expansion)
  TIMESTAMP: "timestamp",
  SOURCE: "source",
  SUBSCRIPTION_ID: "subscription_id",
  TRANSACTION_ID: "transaction_id",
  BILLING_INTERVAL: "billing_interval",
  PAYMENT_METHOD_TYPE: "payment_method_type",
  PREVIOUS_PLAN_TIER: "previous_plan_tier",
  IS_TRIAL: "is_trial",
  TRIAL_END_DATE: "trial_end_date",
  PRORATION_AMOUNT: "proration_amount",
  CANCELLATION_TYPE: "cancellation_type",
  EFFECTIVE_END_DATE: "effective_end_date",
  CANCELLATION_REASON: "cancellation_reason",
  INITIATED_BY: "initiated_by",
  PLAN_TIER: "plan_tier",
  // GA4 ecommerce fields
  CURRENCY: "currency",
  ITEMS: "items",
  BANNER_TYPE: "banner_type",
  OPENED_BY: "opened_by",
  CONSULTATION_TYPE: "consultation_type",
  // Additional consultation (one-time $149 purchase)
  PURCHASE_TARGET: "purchase_target",
  // Non-payment form validation failures (e.g. required shelf description)
  FORM_VALIDATION_ERROR: "form_validation_error",
  // Whether the user typed consultation notes, or the "User provided no
  // details" fallback was sent instead (INH-4988 — description is optional)
  CONSULTATION_DESCRIPTION_PROVIDED: "consultation_description_provided",
  DOCUMENT_VERSION: "document_version",
  // Internal enable-messaging tool (staff-only)
  ERROR_CODE: "error_code",
  LAST_MESSAGE_TYPE: "last_message_type",
  WAS_DISABLED: "was_disabled",
  // Internal knowledge-base sync tool (staff-only). Counts and version only, never the comment
  KNOWLEDGE_BASE_VERSION_ID: "knowledge_base_version_id",
  ARTICLES_ADDED: "articles_added",
  ARTICLES_CHANGED: "articles_changed",
  ARTICLES_REMOVED: "articles_removed",
  ARTICLES_UNCHANGED: "articles_unchanged",
  ARTICLES_TOTAL: "articles_total",
  DURATION_MS: "duration_ms",
  // Connector hand-off page (INH-5704): ids and status only, never form fields
  // Connector hand-off page (INH-5704) and connector chat page (INH-5831): ids and status only, never form
  // fields or the request text
  HANDOFF_ID: "handoff_id",
  REQUEST_ID: "request_id",
  STATUS: "status", // hand-off or request status, or which view a link was clicked from
  STAGE: "stage", // "load" | "submit" | "open"
  // Finished-document events (INH-5930)
  FORMAT: "format", // download file format: "docx" | "pdf" | "markdown"
  HAS_TRACKED_CHANGES: "has_tracked_changes",
  BASED_ON_UPLOAD: "based_on_upload",
  EDIT_TYPE: "edit_type", // DOCUMENT_EDIT_TYPES
  FORMAT_TYPE: "format_type", // DOCUMENT_FORMAT_TYPES
  FILE_EXT: "file_ext", // lowercase extension without the dot, e.g. "pdf"
  CAPABILITY_TILE: "capability_tile", // which tile on the locked document screen
};

export const BUTTON_TYPES = {
  BUTTON_WITH_TEXT: "button-with-text",
  BUTTON_WITH_ICON: "button-with-icon",
  CHECKBOX: "checkbox",
  ENTER_KEY: "enter-key",
  LINK: "link",
};

export const BUTTON_ROLES = {
  OPEN_DOCS_IN_CHAT: "open-docs-in-chat",
  CLOSE_DOCS_IN_CHAT: "close-docs-in-chat",
  SELECT_DOCUMENT_CATEGORY: "select-docuemnt-category",
  FAST_DRAFT: "fast-draft",
  LOGIN: "login",
  SIGNUP: "signup",
  SEND_MESSAGE: "send-message",
  ATTACH_DOCUMENT: "attach-document",
  REMOVE_DOCUMENT: "remove-document",
  DOWNLOAD_DOCUMENT: "download-document",
  RETRY_ATTACHMENT: "retry-attachment",
  OPEN_IN_GOOGLE_DOCS: "open-in-google-docs",
  VIEW_DOCUMENT: "view-document",
  OPEN_DRAFT_INTENT: "open-draft-intent",
  REQUEST: "request",
  START_NEW_CHAT: "start-new-chat",
  CHAT_HISTORY: "chat-history",
  CONTACT_LAWYER: "contact-lawyer",
  CONTACT_HELP: "contact-help",
  MY_PROFILE: "my-profile",
  INHOUSE_BUTTON: "Inhouse-button",
  REQUEST_DOCUMENT_REVIEW: "request-document-review",
  TALK_TO_LAWYER: "talk-to-lawyer",
  // V3.5 legal suggestion pill — kept distinct from the always-on consult CTA
  // so the pill's conversion can be measured on its own.
  LEGAL_SUGGESTION_PILL: "legal-suggestion-pill",
  LEGAL_HEALTH_CHECK: "legal-health-check",
  ONBOARD_LAWYER: "onboard-lawyer",
  MESSAGE_FEEDBACK_POSITIVE: "message-feedback-positive",
  MESSAGE_FEEDBACK_NEGATIVE: "message-feedback-negative",
  NAVIGATION_NEXT: "navigation-next",
  // INH-5557: "Continue with email" on the sign-up modal and the /signup page (the Google click is still Event 116, navigation-next)
  AUTH_METHOD: "auth-method",
  NAVIGATION_BACK: "navigation-back",
  NAVIGATION_CANCEL: "navigation-cancel:",
  NAVIGATION_CLOSE: "navigation-close",
  NAVIGATION_SUBMIT: "navigation-submit",
  NAVIGATION_LINK: "navigation-link",
  ACCESS_DOCUMENT: "access-document",
  SELECT_PAYMENT_PLAN: "select-payment-plan",
  CLOSE_MODAL: "close-modal",
  TOGGLE_PLAN_TYPE_SELECTION: "toggle-plan-type-selection",
  REFRESH_PAYMENT_STATUS: "refresh-payment-status",
  UPGRADE: "upgrade",
  PAY_SECURELY: "pay-securely",
  TRY_AGAIN_PAYMENT: "try-again-payment",
  RETURN_TO_CHAT: "return-to-chat",
  BACK_TO_CHAT_CHECKOUT: "back-to-chat-checkout",
  APPLY_COUPON: "apply-coupon",
  REMOVE_COUPON: "remove-coupon",
  ADD_PHONE: "add-phone",
  DISMISS_PHONE_BANNER: "dismiss-phone-banner",
  PHONE_COLLECTION_CONSENT_CHECKBOX: "phone-collection-consent-checkbox",
  DOCUMENT_VERSION: "document-version",
  PREVIOUS_DOCUMENT_VERSION: "previous_document_version",
  IS_DOCUMENT_EDIT: "is_document_edit",
  IS_USER_DOCUMENT: "is-user-document",
  EDIT: "edit",
  DELETE: "delete",
  CANCEL_EDIT: "cancel-edit",
  DOWNGRADE: "downgrade",
  CANCEL_PLAN: "cancel-plan",
  TOS_ACCEPTANCE_CHECKBOX: "tos-acceptance-checkbox",
  COUNSEL_ADDON_TOGGLE: "counsel-addon-toggle",
  ACTIVITY_SIGNAL_EXPAND: "activity-signal-expand",
  ACTIVITY_SIGNAL_COLLAPSE: "activity-signal-collapse",
  ACTIVITY_SIGNAL_SHOW_SOURCES: "activity-signal-show-sources",
  ABOUT_INHOUSE: "about-inhouse",
  FAQ: "faq",
  // In-shelf "Scroll down for FAQs" anchor — kept distinct from FAQ (the
  // nav link to the FAQ page) so shelf engagement can be measured on its own.
  SCROLL_TO_FAQS: "scroll-to-faqs",
  SUMMARISE_CHAT: "summarise-chat",
  BILLING: "billing",
  ACCOUNT: "account",
  SIGN_OUT: "sign-out",
  UPGRADE_PLAN: "upgrade-plan",
  FREE_MESSAGE_LIMIT_NUDGE_UPGRADE: "free-message-limit-nudge-upgrade",
  REGENERATE_RESPONSE: "regenerate-response",
  OPEN_EMAIL_CONTEXT: "open-email-context",
  DOWNLOAD_EMAIL_ATTACHMENT: "download-email-attachment",
  REMOVE_EMAIL_CONTEXT: "remove-email-context",
  SELECT_EMAIL_THREAD: "select-email-thread",
  COPY_EMAIL_ADDRESS: "copy-email-address",
  CANCEL_EMAIL_CONTEXT: "cancel-email-context",
  ATTACH_EMAIL_CONTEXT: "attach-email-context",
  CLEAR_EMAIL_CONTEXT: "clear-email-context",
  REFRESH_EMAIL_CONTEXT: "refresh-email-context",
  CONTINUE_IN_NEW_CHAT: "continue-in-new-chat",
  OPEN_SUMMARY_SPAWNED_THREAD: "open-summary-spawned-thread",
  UPGRADE_ATTACHMENT_LIMIT: "upgrade-attachment-limit",
  INTERNAL_CHARGE_SUBMIT: "internal-charge-submit",
  INTERNAL_CHARGE_CONFIRM: "internal-charge-confirm",
  INTERNAL_CHARGE_CANCEL: "internal-charge-cancel",
  INTERNAL_CHARGE_EXIT: "internal-charge-exit",
  INTERNAL_ENABLE_MESSAGING_SUBMIT: "internal-enable-messaging-submit",
  INTERNAL_ENABLE_MESSAGING_EXIT: "internal-enable-messaging-exit",
  INTERNAL_KNOWLEDGE_BASE_SYNC_SUBMIT: "internal-knowledge-base-sync-submit",
  INTERNAL_KNOWLEDGE_BASE_SYNC_EXIT: "internal-knowledge-base-sync-exit",
  ATTACH_CONTEXT_MENU: "attach-context-menu",
  AI_CONTEXT_SELECTOR: "ai-context-selector",
  SELECT_AI_CONTEXT: "select-ai-context",
  PURCHASE_ADDITIONAL_CONSULTATION: "purchase-additional-consultation",
  USE_INHOUSE_DIRECTLY_CONTINUE: "use-inhouse-directly-continue",
  QA_CANCEL_SUBSCRIPTION: "qa-cancel-subscription",
  CONNECTOR_HANDOFF_SUBMIT: "connector-handoff-submit",
  CONNECTOR_HANDOFF_OPEN_INHOUSE: "connector-handoff-open-inhouse",
  CONNECTOR_HANDOFF_BACK_TO_FORM: "connector-handoff-back-to-form",
  CONNECTOR_HANDOFF_SWITCH_ACCOUNT: "connector-handoff-switch-account",
  // Locked document screen (INH-5930; wire up with INH-5927)
  LOCKED_DOC_CAPABILITY_TILE: "locked-doc-capability-tile",
  ESIGNATURE_NOTIFY_ME: "esignature-notify-me",
  CONNECTOR_CHAT_OPEN_INHOUSE: "connector-chat-open-inhouse",
  CONNECTOR_CHAT_SWITCH_ACCOUNT: "connector-chat-switch-account",
  CONNECTOR_CHAT_RETRY: "connector-chat-retry",
  BOOK_FREE_CALL: "book-free-call",
  MAYBE_LATER_FREE_CALL: "maybe-later-free-call",
};

export const EVENT_NAMES = {
  AUTO_TRIGGER: "Auto Trigger",
  CLICKED_BUTTON: "Clicked Button",
  SENT_MESSAGE: "Sent Message",
  STARTED_NEW_CHAT: "Started New Chat",
  INITIATED_SIGNUP: "Initiated Signup",
  INITIATED_SIGNIN: "Initiated Signin",
  COMPLETED_SIGNUP: "Completed Signup",
  COMPLETED_SIGNIN: "Completed Signin",
  VIEWED_MODAL: "Viewed Modal",
  RECEIVED_AI_REPLY: "Received AI Reply",
  RECEIVED_DRAFT: "Received Draft",
  INITIATED_CHECKOUT: "Initiated Checkout",
  COMPLETED_CHECKOUT: "Completed Checkout",
  INITIATED_LEGAL_REVIEW: "Initiated Legal Review",
  SUBMITTED_LEGAL_REVIEW: "Submitted Legal Review",
  CLOSED_MODAL: "Closed Modal",
  LANDING_PAGE_TO_SUBSCRIPTION: "Initiated Landing Page to Subscription",
  SENT_ERROR_MESSAGE: "Sent Error Message",
  POSTAUTH_FLOW_COMPLETE: "postauth-flow-complete",
  UNLOCK_DOCUMENT_CLICKED: "Unlock Document Clicked",
  REGENERATE_CLICKED: "Regenerate Clicked",
  REGENERATE_SHOWN: "Regenerate Shown",
  REGENERATE_FAILED: "Regenerate Failed",
  TRIGGERED_REUNLOCKING: "Triggered Reunlocking",
  VIEWED_PAGE: "Viewed Page",
  CHECKOUT_ABANDONED: "Checkout Abandoned",
  ALREADY_SUBSCRIBED: "Already Subscribed",
  PAYMENT_FAILED: "Payment Failed",
  PAYMENT_EXPIRED: "Payment Expired",
  PAYMENT_TOKENIZE_FAILED: "Payment Tokenize Failed",
  PAYMENT_API_ERROR: "Payment API Error",
  COUPON_APPLIED: "Coupon Applied",
  COUPON_REMOVED: "Coupon Removed",
  COUPON_FAILED: "Coupon Failed",
  // A free-trial promo (WELCOME7, INH-5478) validated at checkout.
  TRIAL_COUPON_APPLIED: "Trial Coupon Applied",
  PAYMENT_3DS_REDIRECT: "Payment 3DS Redirect",
  PAYMENT_METHOD_CHANGED: "Payment Method Changed",
  // Checkout sent a customer who has saved cards to card entry: none can pay
  // this purchase, or the backend refused the one they picked (needs_new_card).
  // Never fires for a customer with no saved cards. See CARD_ENTRY_REASON.
  CARD_ENTRY_REQUIRED: "Card Entry Required",
  // Health / reliability tracking
  THREAD_AWAITING_RESPONSE: "Thread Awaiting Response",
  RESPONSE_MILESTONE_RECEIVED: "Response Milestone Received",
  THREAD_RESPONSE_TRIGGERED_AT_60S: "Thread Response Triggered At 60s",
  THREAD_RESPONSE_SLOW: "Thread Response Slow",
  THREAD_RESPONSE_TIMEOUT: "Thread Response Timeout",
  THREAD_RESPONSE_VERY_SLOW: "Thread Response Very Slow",
  THREAD_BLOCKED: "Thread Blocked",
  THREAD_CREATION_FAILED: "Thread Creation Failed",
  THREAD_AI_ERROR: "Thread AI Error",
  THREAD_LIMIT_REACHED: "Thread Limit Reached",
  WS_MAX_RETRIES_REACHED: "WS Max Retries Reached",
  WS_RECONNECTED_WITH_PENDING_RESPONSE: "WS Reconnected With Pending Response",
  WS_IDENTITY_RECONCILED: "Reconciled WS Identity",
  RECOVERED_ANONYMOUS_THREAD: "Recovered Anonymous Thread",
  DEFERRED_THREAD_OWNERSHIP_CHECK: "Deferred Thread Ownership Check",
  MAPPED_ANONYMOUS_THREADS: "Mapped Anonymous Threads",
  ANONYMOUS_THREAD_COOKIE_BUDGET_REACHED: "Anonymous Thread Cookie Budget Reached",
  ANONYMOUS_THREAD_MAPPING_FAILED: "Anonymous Thread Mapping Failed",
  // Wire value is deliberately the pre-existing hardcoded string — PostHog and
  // Segment dashboards key on it. Only the reference moved behind a constant.
  INVALID_THREAD_ERROR: "invalid-thread-error",
  DOC_UNLOCK_DELAYED_START: "Doc Unlock Delayed Start",
  VERSION_MISMATCH_DETECTED: "Version Mismatch Detected",
  VIEWED_ERROR_BOUNDARY: "Viewed Error Boundary",
  // Payment recovery (CRITICAL — alert on any single occurrence)
  PAYMENT_ACTION_PENDING: "Payment Action Pending",
  PAYMENT_ACTION_TIMEOUT: "Payment Action Timeout",
  PAYMENT_ACTION_RECOVERED: "Payment Action Recovered",
  // Phone collection
  PHONE_BANNER_SHOWN: "Phone Banner Shown",
  PHONE_BANNER_DISMISSED: "Phone Banner Dismissed",
  PHONE_NUMBER_ADDED: "Phone Number Added",
  PHONE_NUMBER_ADD_FAILED: "Phone Number Add Failed",
  FIRST_CHAT: "First Chat",
  SUBSCRIPTION_INITIATED: "Subscription Initiated",
  SUBSCRIPTION_COMPLETED: "Subscription Completed",
  SUBSCRIPTION_FAILED: "Subscription Failed",
  SUBSCRIPTION_GATE_HIT: "Subscription Gate Hit",
  SUBSCRIPTION_GATE_DISMISSED: "Subscription Gate Dismissed",
  MARKETING_PROMPT_PREFILLED: "Marketing Prompt Prefilled",
  VIEWED_HIGH_CONTEXT_WARNING: "Viewed High Context Warning",
  VIEWED_SUBSCRIBED_MESSAGE_LIMIT: "Viewed Subscribed Message Limit",
  VIEWED_FREE_MESSAGE_WARNING: "Viewed Free Message Warning",
  VIEWED_PREV_CHAT_SUMMARY: "Viewed Previous Chat Summary",
  VIEWED_SUMMARY_SPAWNED_THREADS: "Viewed Summary Spawned Threads",
  // Upload-reliability funnel (F-fe). Values are intentionally snake_case (NOT the
  // usual Title Case) so they join 1:1 with the backend upload funnel by
  // storage_id / thread_id. Do not rename without coordinating the backend funnel.
  UPLOAD_PRESIGNED_REQUESTED: "upload_presigned_requested",
  UPLOAD_S3_SUCCEEDED: "upload_s3_succeeded",
  UPLOAD_S3_FAILED: "upload_s3_failed",
  ATTACHMENT_COMPLETE_CONFIRMED: "attachment_complete_confirmed",
  ATTACHMENT_COMPLETE_FAILED: "attachment_complete_failed",
  ATTACHMENT_CARD_RESOLVED: "attachment_card_resolved",
  TURN_CLIENT_TIMEOUT_EXIT: "turn_client_timeout_exit",
  VIEWED_ATTACHMENT_LIMIT: "Viewed Attachment Limit",
  ACTIVATED_LIST_FORMATTING: "Activated List Formatting",
  INDENTED_LIST_ITEM: "Indented List Item",
  // Subscription lifecycle events (data-layer expansion)
  NEW_PAID_SUBSCRIBER: "New Paid Subscriber",
  FIRST_SUBSCRIPTION: "First Subscription",
  UPGRADE: "Upgrade",
  CANCELLATION: "Cancellation",
  // Internal manual charge (staff-only admin tool)
  INTERNAL_CHARGE_ACCESS_DENIED: "Internal Charge Access Denied",
  INTERNAL_CHARGE_SUCCEEDED: "Internal Charge Succeeded",
  INTERNAL_CHARGE_FAILED: "Internal Charge Failed",
  // Internal enable-messaging tool (staff-only)
  INTERNAL_ENABLE_MESSAGING_ACCESS_DENIED: "Internal Enable Messaging Access Denied",
  INTERNAL_ENABLE_MESSAGING_SUCCEEDED: "Internal Enable Messaging Succeeded",
  INTERNAL_ENABLE_MESSAGING_FAILED: "Internal Enable Messaging Failed",
  // Internal knowledge-base sync tool (staff-only)
  INTERNAL_KNOWLEDGE_BASE_SYNC_ACCESS_DENIED: "Internal Knowledge Base Sync Access Denied",
  INTERNAL_KNOWLEDGE_BASE_SYNC_SUCCEEDED: "Internal Knowledge Base Sync Succeeded",
  INTERNAL_KNOWLEDGE_BASE_SYNC_FAILED: "Internal Knowledge Base Sync Failed",
  VIEWED_BANNER: "Viewed Banner",
  CLOSED_BANNER: "Closed Banner",
  // Additional consultation (one-time $149 purchase)
  CONSULTATION_BOOKED: "Consultation Booked",
  ADDITIONAL_CONSULTATION_PURCHASED: "Additional Consultation Purchased",
  ADDITIONAL_CONSULTATION_CREDIT_RACE: "Additional Consultation Credit Race",
  // Document edit fidelity tracking (INH-5198 related)
  DOCUMENT_EDIT_COMPLETED: "Document Edit Completed",
  // Document generation reliability (Bryan-requested telemetry)
  DOCUMENT_GENERATION_FAILED: "Document Generation Failed",
  // Connector hand-off page (INH-5704)
  SUBMITTED_CONNECTOR_HANDOFF: "Submitted Connector Handoff",
  CONNECTOR_HANDOFF_FAILED: "Connector Handoff Failed",
  // Connector chat page (INH-5831)
  OPENED_CONNECTOR_CHAT: "Opened Connector Chat",
  CONNECTOR_CHAT_FAILED: "Connector Chat Failed",
  // Finished-document events (INH-5930)
  DOCUMENT_DOWNLOADED: "Document Downloaded",
  DOCUMENT_EDITED_BY_USER: "Document Edited By User", // generated doc version > 1 (edit_type text); field fill comes with INH-5928
  DOCUMENT_FORMAT_APPLIED: "Document Format Applied", // wire up with INH-5929 (letterhead)
};

// Values for EVENT_PARAMETERS.EDIT_TYPE on DOCUMENT_EDITED_BY_USER (INH-5930)
export const DOCUMENT_EDIT_TYPES = {
  TEXT: "text",
  FIELD_FILL: "field_fill",
};

// Values for EVENT_PARAMETERS.FORMAT_TYPE on DOCUMENT_FORMAT_APPLIED (INH-5930)
export const DOCUMENT_FORMAT_TYPES = {
  PLEADING_PAPER: "pleading_paper",
  LETTERHEAD: "letterhead",
  OTHER: "other",
};

export const PAGE_NAMES = {
  LANDING: "landing",
  TRY_CHAT: "try-chat",
  TRY_LANDING: "try-landing",
  HOME: "home",
  CHAT: "chat",
  SHARED_CHAT: "shared-chat",
  DOCUMENT_LIBRARY: "document-library",
  SIGN_IN: "sign-in",
  SIGN_UP: "sign-up",
  CHECKOUT: "checkout",
  PAYMENT_STATUS: "payment-status",
  INTERNAL_MANUAL_CHARGE: "internal-manual-charge",
  INTERNAL_ENABLE_MESSAGING: "internal-enable-messaging",
  INTERNAL_KNOWLEDGE_BASE_SYNC: "internal-knowledge-base-sync",
  NOT_FOUND: "not-found",
  CONSULTATION_HANDOFF: "consultation-handoff",
  CONNECTOR_CHAT: "connector-chat",
};

export const MODAL_NAMES = {
  DOCUMENT_UPLOAD_LIMIT_REACHED: "document-upload-limit-reached",
  DOCUMENT_UPLOAD_FAILED: "document-upload-failed",
  FAST_DRAFT: "fast-draft",
  SUBMIT_FEEDBACK: "submit-feedback",
  UNSUPPORTED_FILE_FORMAT: "unsupported-file-format",
  TEN_K_WORD_COUNT: "ten_k_word_count",
  YOU_ARE_ALL_SET: "you-are-all-set",
  VIEW_DOC_IN_MODAL: "view-doc-in-modal",
  CHAT_ACTIONS: "chat-actions",
  DELETE_THREAD_MODAL: "delete-thread-modal",
  SHARE_THREAD_MODAL: "shared-thread-modal",
  RENAME_THREAD_MODAL: "rename-thread-modal",
  SIGN_UP: "sign-up",
  SIGN_IN: "sign-in",
  SIDENAV: "sidenav",
  PRICING_MODAL_COUNSEL: "pricing-modal-counsel",
  PRICING_MODAL_PRO: "pricing-modal-pro",
  PRICING_MODAL_CONSULTATION: "pricing-modal-consultation",
  PRICING_MODAL_ALL_PLANS: "pricing-modal-all-plans",
  SINGLE_PAYMENT_MODAL: "single-payment-modal",
  MULTI_PAYMENT_MODAL: "multi-payment-modal",
  LEGAL_REVIEW: "legal-review",
  CHECKOUT_MODAL: "checkout-modal",
  SUPPORT: "support",
  CONTACT_HELP_MODAL: "contact-help-modal",
  PERSONALIZE_POPUP: "personalize-popup",
  PAYMENT_STATUS_CHECK: "payment-status-check",
  FREE_MESSAGES_LIMIT_REACHED: "free-messages-limit-reached",
  DOCUMENT_LENGTH_EXCEEDED_POPUP: "document-length-exceeded-popup",
  FILE_SIZE_EXCEEDED_POPUP: "file-size-exceeded-popup",
  FILEUPLOAD_DELAY_POPUP: "fileupload-delay-popup",
  NEGATIVE_FEEDBACK_MODAL: "negative-feedback-modal",
  SMALL_SCREEN_MODAL: "small-screen-modal",
  FREE_CALL_POPUP: "free-call-popup",
  CALL_SCHEDULED_POPUP: "call-scheduled-popup",
  SUBSCRIPTION_STATUS_REFRESH_MODAL: "subscription-status-refresh-modal",
  DOCUMENT_LIBRARY: "document-library",
  CHAT_HISTORY: "chat-history",
  SIGNIN_PAGE: "signin-page",
  SIGNUP_PAGE: "signup-page",
  OTP_VERIFICATION_PAGE: "otp-verification-page",
  PASSWORD_PAGE_SIGNING_JOURNEY: "password-page-signing-journey",
  EMAIL_VERIFICATION_PAGE: "email-verification-page",
  UNKNOWN_PAGE_AUTH_JOURNEY: "unknown-page-auth-journey",
  FIND_BEST_LAWYER_MODAL: "find-best-lawyer",
  PLAN_COMPARISON_MODAL: "plan-comparison-modal",
  TOP_NAV: "top-nav",
  TALK_TO_LAWYER_BUTTON: "talk-to-lawyer-button",
  CHATBOX: "chatbox",
  RENAME_DOCUMENT_MODAL: "rename-document-modal",
  DOWNLOAD_DOCUMENT_DROPDOWN: "download-document-dropdown",
  DRAFT_DOCUMENT_QUESTIONARE_MODAL: "draft-document-questionare-modal",
  NOT_SUPPORTED_AREA: "not-supported-area",
  SIGNUP_ALERT_POPUP: "signup-alert-popup",
  PAYMENT_STATUS_POLLING: "payment-status-polling",
  PAYMENT_STATUS_SUCCESS: "payment-status-success",
  PAYMENT_STATUS_FAILED: "payment-status-failed",
  DOCUMENT_PREVIEW_CARD: "document-preview-card",
  DOCUMENT_PANEL: "document-panel",
  DOCUMENT_CARD: "document-card",
  LOCKED_DOCUMENT_CARD: "locked-document-card",
  MEMORY_SHELF: "memory-shelf",
  CHECKOUT_SLIDE: "checkout-slide",
  DOWNGRADE_CONFIRM_MODAL: "downgrade-confirm-modal",
  CANCEL_CONFIRM_MODAL: "cancel-confirm-modal",
  CONSULTATION_SHELF: "consultation-shelf",
  EMAIL_THREAD_DRAWER: "email-thread-drawer",
  EMAIL_CONTEXT_POPOVER: "email-context-popover",
  FREE_ATTACHMENT_LIMIT_REACHED: "free-attachment-limit-reached",
  USE_INHOUSE_DIRECTLY_MODAL: "use-inhouse-directly-modal",
};

export const BANNER_TYPES = {
  PRIVILEGED_CHAT_STARTED: "privileged-chat-started",
  PRIVILEGED_CHAT_ENDED: "privileged-chat-ended",
  SERVICE_OUTAGE: "service-outage",
};

export function getPageName() {
  const path = window.location.href;
  if (path.includes("/chat") || path.includes("/draft") || path.includes("/ask/")) {
    return PAGE_NAMES.CHAT;
  } else if (path.includes("/home")) {
    return PAGE_NAMES.HOME;
  } else if (path.includes("/document-library")) {
    return PAGE_NAMES.DOCUMENT_LIBRARY;
  } else if (path.includes("/sign-in")) {
    return PAGE_NAMES.SIGN_IN;
  } else if (path.includes("/sign-up")) {
    return PAGE_NAMES.SIGN_UP;
  } else if (path.includes("/try") && path.includes("thread_id=")) {
    return PAGE_NAMES.TRY_CHAT;
  } else if (path.includes("/try") && !path.includes("thread_id=")) {
    return PAGE_NAMES.TRY_LANDING;
  } else if (path.includes("/checkout")) {
    return PAGE_NAMES.CHECKOUT;
  } else if (path.includes("/payment-status")) {
    return PAGE_NAMES.PAYMENT_STATUS;
  }
  return "others";
}
